//#Global Imports
import React from "react";
import clsx from "clsx";
import { useNavigate } from "react-router-dom";
//#end Global Imports

//#Local Imports
import Modal from "../../../../components/ui/Modal";
import Button from "../../../../components/ui/Button";
import DocumentsListSection from "./DocumentsListSection";
import PanCardSection from "./PanCardSection";
import DrivingLicenseSection from "./DrivingLicenseSection";
import IndianPassportSection from "./IndianPassportSection";
import VoterIdCardSection from "./VoterIdCardSection";
import AadharCardSection from "./AadharCardSection";
import IUserDocuments from "../../userDocuments";
import { Mixpanel } from "../../../../constants/mixpanel";
// import CKYCSection from "./CKYCSection";
//#end Local Imports

const UploadDocumentsModal: React.FC<IUserDocuments.IUploadDocumentsModalProps> = ({
  isModalOpen,
  setIsModalOpen,
  docType,
  numberOfVerifiedDoc,
  panCardDetails,
  setDocType,
  verifiedDocumentsData,
  getColor,
  handleDeleteDoc,
  handleChangeUpload,
  handleEVerifyPanCard,
  adharCardDetails,
  setDrivingLicenseDetails,
  sendAdharOtp,
  buttonLoader,
  entityId,
  dateKey,
  date,
  saveAdharOTPValue,
  adharOTPError,
  drivingLicenseDetails,
  handleEverifyDL,
  passportDetails,
  handlePassportBackVerification,
  handlePassportVerification,
  voterIDCardDetails,
  setVoterIDCardDetails,
  handleEVerifyVoterCard,
  setPassportDetails,
  setPanCardDetails,
  handlePanDobChangeHandler,
  handleDlDobChangeHandler,
  handlePassportDobChangeHandler,
  docDob,
  // ckycPhase,
  // validateCkycOtpHandler,
  // verifyCKYCHandler,
  // downloadCkycHandler,
  // sendCkycOtpHandler,
  // saveCkycAdharOTPValue,
  // ckycMessage,
  ckycStatus,
  // ckycData,
  // isReSendOtp,
  aadhaarLinked,
  handleVerifyAdharCard,
}) => {
  const navigate = useNavigate();

  return (
    <Modal
      modalClass="!pt-4 md:pr-11 !rounded xl:overflow-hidden !overflow-y-scroll max-h-[90%] lg:max-h-[90%] w-[80vw] ml-36"
      headerClass="mt-2 bg-red"
      visible={isModalOpen === "2"}
      closeHandler={() => {
        setIsModalOpen("");
        navigate("/remitter");
      }}
    >
      <div
        className={clsx(
          docType === "" ? "flex" : "hidden lg:flex",
          "text-lg font-bold justify-center text-black-200 lg:mb-[62px]",
        )}
      >
        Upload document for KYC
      </div>
      <div className="flex flex-col items-start mb-4 -lg:mt-6 w-[70vw]">
        <div className="grid w-full grid-1 lg:grid-cols-6 lg:divide-black lg:divide-x-[1px] lg:divide-opacity-[0.15]">
          <DocumentsListSection
            docType={docType}
            panCardDetails={panCardDetails}
            setDocType={setDocType}
            verifiedDocumentsData={verifiedDocumentsData}
            getColor={getColor}
            ckycStatus={ckycStatus}
          />
          {docType === "PAN_CARD" && (
            <PanCardSection
              panCardDetails={panCardDetails}
              handleDeleteDoc={handleDeleteDoc}
              handleChangeUpload={handleChangeUpload}
              handleEVerifyPanCard={handleEVerifyPanCard}
              setPanCardDetails={setPanCardDetails}
              handlePanDobChangeHandler={handlePanDobChangeHandler}
              docDob={docDob}
              aadhaarLinked={aadhaarLinked}
              buttonLoader={buttonLoader}
            />
          )}
          {/* {docType === "CKYC" && (
            <CKYCSection
              ckycPhase={ckycPhase}
              validateCkycOtpHandler={validateCkycOtpHandler}
              verifyCKYCHandler={verifyCKYCHandler}
              downloadCkycHandler={downloadCkycHandler}
              sendCkycOtpHandler={sendCkycOtpHandler}
              saveCkycAdharOTPValue={saveCkycAdharOTPValue}
              ckycMessage={ckycMessage}
              setDocType={setDocType}
              ckycStatus={ckycStatus}
              ckycData={ckycData}
              date={date}
              dateKey={dateKey}
              isReSendOtp={isReSendOtp}
            />
          )} */}
          {docType === "AADHAR_CARD" && (
            <AadharCardSection
              adharCardDetails={adharCardDetails}
              handleDeleteDoc={handleDeleteDoc}
              handleChangeUpload={handleChangeUpload}
              sendAdharOtp={sendAdharOtp}
              buttonLoader={buttonLoader}
              entityId={entityId}
              dateKey={dateKey}
              date={date}
              saveAdharOTPValue={saveAdharOTPValue}
              adharOTPError={adharOTPError}
              handleVerifyAdharCard={handleVerifyAdharCard}
            />
          )}
          {docType === "DRIVING_LICENCE" && (
            <DrivingLicenseSection
              drivingLicenseDetails={drivingLicenseDetails}
              handleDeleteDoc={handleDeleteDoc}
              handleChangeUpload={handleChangeUpload}
              setDrivingLicenseDetails={setDrivingLicenseDetails}
              handleEverifyDL={handleEverifyDL}
              handleDlDobChangeHandler={handleDlDobChangeHandler}
              docDob={docDob}
              buttonLoader={buttonLoader}
            />
          )}
          {docType === "PASSPORT_FRONT" && (
            <IndianPassportSection
              passportDetails={passportDetails}
              handleDeleteDoc={handleDeleteDoc}
              handleChangeUpload={handleChangeUpload}
              handlePassportBackVerification={handlePassportBackVerification}
              handlePassportVerification={handlePassportVerification}
              setPassportDetails={setPassportDetails}
              handlePassportDobChangeHandler={handlePassportDobChangeHandler}
              docDob={docDob}
              buttonLoader={buttonLoader}
            />
          )}
          {docType === "VOTER_CARD" && (
            <VoterIdCardSection
              voterIDCardDetails={voterIDCardDetails}
              handleDeleteDoc={handleDeleteDoc}
              handleChangeUpload={handleChangeUpload}
              setVoterIDCardDetails={setVoterIDCardDetails}
              handleEVerifyVoterCard={handleEVerifyVoterCard}
              buttonLoader={buttonLoader}
            />
          )}
        </div>
        <div
          className={clsx(
            docType === "" ? "flex" : "hidden lg:flex",
            "items-center justify-end w-full mt-8",
          )}
        >
          <Button
            bgColor={numberOfVerifiedDoc > 1 ? "bg-primary" : "bg-gray-400"}
            fontStyle={{
              fontFamily: "",
              fontSize: "text-lg",
              fontWeight: "font-bold",
              fontColor: "text-white",
            }}
            borderStyle={{
              borderWidth: "border-none",
              borderRadius: "rounded",
            }}
            className="w-10/12 py-3 lg:w-1/4 kyc-submit"
            onClickHandler={() => {
              setIsModalOpen("KYCVerified");
              numberOfVerifiedDoc === 2 && Mixpanel.track("Submit 2 of 2");
            }}
            disabled={!panCardDetails?.isPanUploaded || numberOfVerifiedDoc !== 2}
          >
            {numberOfVerifiedDoc === 0
              ? "Submit 0 of 2"
              : numberOfVerifiedDoc === 2
              ? "Submit 2 of 2"
              : panCardDetails?.isPanUploaded && "Submit 1 of 2"}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default UploadDocumentsModal;
